import { getAuth } from "firebase/auth";
import { getUserData } from "../services/userService";

const API_URL = "https://pipcommands-5dhfwyjvzq-uc.a.run.app";
const REPORT_URL = "https://pipreporthandler-5dhfwyjvzq-uc.a.run.app";

export async function callPipCommand(command, input = "", tab) {
  if (!tab) {
    return { success: false, message: "Tab context is required." };
  }

  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      return { success: false, message: "Authentication required." };
    }

    const userData = await getUserData(currentUser.uid);
    if (userData?.userLevel === "Basic") {
      return {
        success: false,
        message: "Upgrade your trader level to use PIP commands.",
      };
    }

    const idToken = await currentUser.getIdToken(true); 

    let action = command.toLowerCase().trim();
    if (action.startsWith('/pip')) {
      action = action.replace('/pip', '').trim();
    }

    const isReport = action === "report";
    const targetUrl = isReport ? REPORT_URL : API_URL;

    const body = {
      command: action,
      input: input.trim(),
      channel: tab,
    };

    const res = await fetch(targetUrl, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${idToken}`,
      },
      body: JSON.stringify(body),
    });

    const contentType = res.headers.get("content-type");
    let data = {};
    if (contentType && contentType.includes("application/json")) {
      data = await res.json();
    }

    if (!res.ok) {
      return {
        success: false,
        message: data.message || data.error || `Server Error: ${res.status}`,
      };
    }

    return { success: true, data };
  } catch (err) {
    console.error("PIP Service Error:", err);
    return { success: false, message: `Connection failed: ${err.message}` };
  }
}